import React from "react";
import { connect } from "react-redux";
import { compose, lifecycle } from "recompose";
import Button from "react-md/lib/Buttons/Button";

import { setActiveHost } from "../actions/activeActions";
import { removeHost } from "../actions/resourceActions";

const RemoveHost = ({ history, activeHost, removeHost }) => {
  if (activeHost)
    return (
      <div>
        <p>Chcete odstranit host "{activeHost.name}"?</p>
        <div className="flex-row flex-right">
          <Button
            flat
            label="Zrušit"
            className="btn"
            onClick={() => history.push(`/hosts/${activeHost.id}`)}
          />
          <Button
            flat
            primary
            label="Odstranit"
            className="btn btn-primary"
            onClick={async () =>
              (await removeHost(activeHost.id)) && history.push("/hosts")}
          />
        </div>
      </div>
    );

  return <div />;
};

export default compose(
  connect(({ active: { activeHost } }) => ({ activeHost }), {
    setActiveHost,
    removeHost
  }),
  lifecycle({
    componentWillUnmount() {
      const { setActiveHost } = this.props;

      setActiveHost(null);
    }
  })
)(RemoveHost);



// WEBPACK FOOTER //
// ./src/pages/RemoveHost.js